export default [
  { name: 'USPS', label: 'USPS' },
  { name: 'NEWGISTICS', label: 'NEWGISTICS' },
];
